module.exports = __webpack_public_path__ + "media/images/cards/cc-mastercard-73bb0b54749adbf9ae2789e2a30cb5ae.svg";